import { omit } from 'lodash-es'
import { useAuthStore } from 'src/stores/authStore.js'

// Our hand-rolled solution for simple i18n translations
// More efficient for our simple use-case than using one of the heavier 3rd party i18n libraries.

let activeTranslations = new Map()
let activeLanguage = null

const appLocales = {
    en: {
        source: () => import('i18n/en.json'),
        overrides: {
            nz: () => import('i18n/en_nz.json'),
            uk: () => import('i18n/en_uk.json'),
            ie: () => import('i18n/en_uk.json'),
        },
    },
    fr: {
        source: () => import('i18n/fr.json'),
        overrides: {},
    },
}

const dayJsLocales = {
    en: () => import('dayjs/locale/en.js'),
    fr: () => import('dayjs/locale/fr.js'),
}

export async function setActiveLanguage(langKey = null) {
    if (!langKey) langKey = getDefaultLangKey()
    if (!appLocales[langKey]) langKey = 'en' // Unknown language? Default to english

    dayJsLocales[langKey]().then(() => dayjs.locale(langKey)) // cant use await here for some reason

    let locale = appLocales[langKey]
    let lines = await loadLanguageLines(locale.source)

    // Do we have any regional i18n overrides?
    let region = useAuthStore().dataSourceRegion
    let regionOverride = locale.overrides[region?.code?.toLowerCase()]
    if (regionOverride) {
        lines = {
            ...lines,
            ...await loadLanguageLines(regionOverride),
        }
    }

    activeTranslations = new Map(Object.entries(lines))
    activeLanguage = langKey
}

async function loadLanguageLines(importFn) {
    return omit(await importFn(), ['default']) // Remove a few invalid i18n keys due to the vite json import
}

export function getDefaultLangKey() {
    return (navigator.language || '')
        .toLowerCase()
        .split('-')?.[0]
}

export function getActiveLanguage() {
    return activeLanguage
}

export function trans(key, replacements = null) {
    if (!activeTranslations.has(key)) return key

    let translated = activeTranslations.get(key)
    if (replacements) {
        for (const key in replacements) {
            translated = translated.replaceAll(`:${key}`, replacements[key])
        }
    }
    return translated
}
